import React, { useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin, Card, Col, notification, Row, Select, Button } from 'antd'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateEventStatusByVenueId, filterEventsByVenueId } from '~actions'
import { getCurrentUser } from '~context'

import { MultiSelect, PageLayout } from '~stories'

import './BulkEventPublisher.modules.css'

const PAGE_TITLE = 'Event Bulk Updates'
const { Option } = Select

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const BulkEventPublisher = ({
  allVenues: allVenuesProps,
  filterEventsByVenueId,
  updateEventStatusByVenueId,
  publishedEvents: publishedEventsProps,
  unPublishedEvents: unPublishedEventsProps,
  message,
  success
}) => {
  const [selectedVenue, setSelectedVenue] = useState()
  const [selectedVenueIndex, setSelectedVenueIndex] = useState()
  const { access_token: accessToken, userDetails: { isContentEditor } } = getCurrentUser()
  const [isDataLoaded, setIsDataLoaded] = useState()

  const [publishedEvents, setPublishedEvents] = useState()
  const [unPublishedEvents, setUnPublishedEvents] = useState()

  useEffect(() => {
    if (publishedEventsProps) {
      setIsDataLoaded(true)
      setPublishedEvents(publishedEventsProps)
    }
  }, [publishedEventsProps])

  useEffect(() => {
    if (unPublishedEventsProps) {
      setUnPublishedEvents(unPublishedEventsProps)
    }
  }, [unPublishedEventsProps])

  const onSubmitHandler = async (event) => {
    event.preventDefault()
    if (!isContentEditor) {
      notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
      return
    }
    setIsDataLoaded(false)
    const publishedEventIds = publishedEvents.map(event => event?.id)
    const unPublishedEventIds = unPublishedEvents.map(event => event?.id)
    updateEventStatusByVenueId(selectedVenue?.value, { publishedEventIds, unPublishedEventIds }, accessToken)
  }

  useEffect(() => {
    if (success) {
      setIsDataLoaded(true)
      notification.info({ message: message })
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    } else if (!success && message) {
      notification.error({ message: message })
    }
  }, [success, message])

  const managePageLists = (items, source, dest, sourceFn, destFn) => {
    const selectedItems = Array.isArray(items)
      ? items
      : [items]
    const clonedSource = [...source]
    let clonedDest = [...dest]
    selectedItems.forEach(item => {
      const selectedEventIndex = clonedSource.findIndex(event => event?.title === item?.title)
      const [itemToMove] = clonedSource.splice(selectedEventIndex, 1)
      clonedDest = [...clonedDest, itemToMove]
    })
    sourceFn([...clonedSource])
    destFn([...clonedDest])
  }

  const onListAdd = (selectedEvent, allEvents, selectedEvents, setallEvents, setSelectedEvents) => {
    managePageLists(selectedEvent, allEvents, selectedEvents, setallEvents, setSelectedEvents)
  }

  const onListRemove = (selectedEvent, allEvents, selectedEvents, setallEvents, setSelectedEvents) => {
    managePageLists(selectedEvent, selectedEvents, allEvents, setSelectedEvents, setallEvents)
  }

  const onListFilter = (allListItems, filterValue) => {
    const testRegExp = new RegExp(filterValue, 'i')
    return allListItems.filter(item => {
      const title = `${item?.title}`
      return testRegExp.test(title)
    })
  }

  return (
    <PageLayout title={PAGE_TITLE}>
      <form noValidate onSubmit={(event) => onSubmitHandler(event)}>

        <div className="form-flag-row">
          <Select
            allowClear
            onChange={(value) => {
              const venueId = allVenuesProps[value] ? allVenuesProps[value].value : null
              setSelectedVenue(allVenuesProps[value])
              setSelectedVenueIndex(value)
              if (venueId) {
                setIsDataLoaded(false)
                filterEventsByVenueId({ venueId })
              }
            }}
            onClear={() => {
              setSelectedVenue()
              setSelectedVenueIndex(-1)
            }}
            placeholder='Select Venue'
            style={{ width: '300px' }}
            value={selectedVenueIndex}
          >
            {
              allVenuesProps?.map((venueLogo, index) => <Option key={index} value={index}>{venueLogo.label}</Option>)
            }
          </Select>
          <br />
          <br />
          <Card title="">
            <Row>
              <Col span={16}>
                { selectedVenue?.value &&
                  <>
                    {isDataLoaded ? <MultiSelect
                      availableListHeaderString='UnPublished Events'
                      availableListItems={unPublishedEvents}
                      displayField="title"
                      onAdd={(items) => onListAdd(items, unPublishedEvents, publishedEvents, setUnPublishedEvents, setPublishedEvents)}
                      onFilter={onListFilter}
                      onRemove={(items) => onListRemove(items, unPublishedEvents, publishedEvents, setUnPublishedEvents, setPublishedEvents)}
                      selectedListHeaderString='Published Events'
                      selectedListItems={publishedEvents}
                      valueField='_id'
                    /> : <Spin indicator={<LoadingOutlined spin style={{ fontSize: 48 }} />} />}
                  </>
                }
              </Col>
            </Row>
          </Card>
        </div>
        <div className="form-row">
          <Button disabled={!selectedVenue} htmlType='submit' type="primary">
            Update
          </Button>

        </div>
      </form>

    </PageLayout>
  )
}

const mapStateToProps = ({ dashboard, eventsUpdate }) => ({
  allVenues: dashboard.allVenues,
  publishedEvents: eventsUpdate?.publishedEvents,
  unPublishedEvents: eventsUpdate?.unPublishedEvents,
  message: eventsUpdate.message,
  success: eventsUpdate.success
})

const mapDispatchToProps = {
  updateEventStatusByVenueId,
  filterEventsByVenueId
}

BulkEventPublisher.propTypes = {
  allVenues: PropTypes.array,
  filterEventsByVenueId: PropTypes.func,
  message: PropTypes.string,
  publishedEvents: PropTypes.array,
  success: PropTypes.bool,
  unPublishedEvents: PropTypes.array,
  updateEventStatusByVenueId: PropTypes.func
}

BulkEventPublisher.defaultProps = {

}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkEventPublisher)
